import { render, staticRenderFns } from "./SelectPaginateUnit.vue?vue&type=template&id=a2640b10&scoped=true"
import script from "./SelectPaginateUnit.vue?vue&type=script&lang=js"
export * from "./SelectPaginateUnit.vue?vue&type=script&lang=js"
import style0 from "./SelectPaginateUnit.vue?vue&type=style&index=0&id=a2640b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2640b10",
  null
  
)

export default component.exports